export default defineNuxtPlugin(() => {
    const datadog = useDatadog()
    // Unhandled promise rejections (client-side)
    window.addEventListener('unhandledrejection', (event) => {
        if (!datadog) {
            return
        }
        // Log to datadog error
        datadog.logError(event.reason, {})
    })

    // nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    //     // Log the error to your error tracking service (e.g., Sentry, Bugsnag)

    //     // You can also display a user-friendly notification
    //     // e.g., using a toast library
    //     // useToast().add({
    //     //   title: 'Oops!',
    //     //   description: 'Something went wrong. Please try again.',
    //     //   color: 'red'
    //     // });
    // }
})
